import type { Predicate } from './types';

export const every =
    <T>(predicates: Predicate<T>[]): Predicate<T> =>
    (candidate) =>
        predicates.every((predicate) => predicate(candidate));
